import { render, staticRenderFns } from "./TheNavbarVerticalPerfil.vue?vue&type=template&id=61a3add7&scoped=true&"
import script from "./TheNavbarVerticalPerfil.vue?vue&type=script&lang=js&"
export * from "./TheNavbarVerticalPerfil.vue?vue&type=script&lang=js&"
import style1 from "./TheNavbarVerticalPerfil.vue?vue&type=style&index=1&id=61a3add7&prod&scoped=true&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a3add7",
  null
  
)

export default component.exports